var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6812 17.4448L14.0367 4.20418C13.6116 3.46793 12.8502 3.02832 12 3.02832C11.1498 3.02832 10.3884 3.46793 9.96331 4.20418L2.31884 17.4448C1.89372 18.1811 1.89372 19.0603 2.31884 19.7966C2.74395 20.5328 3.50528 20.9724 4.35551 20.9724H19.6445C20.4946 20.9724 21.256 20.5328 21.6812 19.7966C22.1063 19.0603 22.1063 18.1811 21.6812 17.4448ZM20.6664 19.2107C20.4531 19.5802 20.0711 19.8007 19.6445 19.8007H4.35551C3.92887 19.8007 3.54684 19.5802 3.33356 19.2107C3.12028 18.8413 3.12028 18.4002 3.33356 18.0307L10.9781 4.79007C11.1914 4.42062 11.5734 4.20007 12 4.20007C12.4266 4.20007 12.8087 4.42062 13.0219 4.79007L20.6664 18.0307C20.8797 18.4002 20.8797 18.8413 20.6664 19.2107Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7029 8.25H11.2969V15.2804H12.7029V8.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.6865C11.4831 16.6865 11.0626 17.107 11.0626 17.6239C11.0626 18.1408 11.4831 18.5613 12 18.5613C12.5169 18.5613 12.9374 18.1408 12.9374 17.6239C12.9374 17.107 12.5169 16.6865 12 16.6865Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.8f6e48154b4a67f8ad2155bebbd5c468.svg";
export { ForwardRef as ReactComponent };